<div class="pwa-status" [ngClass]="statusClass">
  <mat-icon 
    [matTooltip]="statusMessage"
    [ngClass]="iconClass">
    {{ statusIcon }}
  </mat-icon>
</div>
